import { render } from "./MerchItemInEditOrder.vue?vue&type=template&id=6c71a456&scoped=true"
import script from "./MerchItemInEditOrder.vue?vue&type=script&lang=js"
export * from "./MerchItemInEditOrder.vue?vue&type=script&lang=js"

import "./MerchItemInEditOrder.vue?vue&type=style&index=0&id=6c71a456&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c71a456"]])

export default __exports__